import i18n from "@sg/i18n";
import cloneDeep from "lodash/cloneDeep";
import { UserResourceType } from "~/hooks/query";
import authStore from "~/store/auth";
import { Action, AllResources, PermissionType, Resource, RoleV2 } from "~/types";

export function hasRole(role: RoleV2, user?: Partial<UserResourceType>) {
  if (role === RoleV2.SUPER_ADMIN) {
    return authStore.getState().superAdmin;
  }
  const roles = user?.roles || [];
  return !!roles?.find((r) => r.role === role);
}

export function isAuthorized(roles: RoleV2[] = []) {
  const { superAdmin } = authStore.getState();
  const memberRoleData = authStore.getState().userInfo?.roles || [];
  const memberRoles = memberRoleData.map((r) => r.role);

  if (!roles.length || superAdmin) {
    return true;
  }

  return roles.some((role) => {
    return memberRoles.includes(role);
  });
}

export function getRoleActionLevel(level: number) {
  const result = Object.entries(Action).find(([, value]) => {
    if (level === value) {
      return true;
    }
  });
  return result ? result[0] : i18n.t("unknown")?.toUpperCase();
}

// Given a new set of resources, update the specified permission data.
// Takes into account any newly introduced wildcard permissions.
export function updatePermissions(permissions: PermissionType, resource: Resource, level: Action, resources: string[]) {
  const clonedPerms = cloneDeep(permissions || {});
  const oldResourcePermission = clonedPerms[resource] || {};
  const includesAll = resources.includes(AllResources);

  if (includesAll) {
    Object.entries(oldResourcePermission).forEach(([k, v]) => {
      const oldResourceLevel = Number(k);
      if (level !== oldResourceLevel && v.includes(AllResources)) {
        oldResourcePermission[oldResourceLevel] = [];
      }
    });
  }

  clonedPerms[resource] = {
    ...oldResourcePermission,
    [level]: includesAll ? [AllResources] : resources,
  };

  return clonedPerms;
}
